/**
* 采集数据录入
*/
const collectionData = {

  factitiousEnterCollectionData: "/api/factitiousEnterCollectionData",//录入采集数据
  getCollectionDataFactitiousEnteringLog1: "/api/getCollectionDataFactitiousEnteringLog1",//查询采集数据录入记录
  getCollectionDataFactitiousEnteringLog2: "/api/getCollectionDataFactitiousEnteringLog2",//查询采集数据录入记录


  factitiousEnterQuantitiyData: "/api/factitiousEnterQuantitiyData",//录入统计数据
  getQuantitiyDataFactitiousEnteringLog1: "/api/getQuantitiyDataFactitiousEnteringLog1",//查询统计数据录入记录
  getQuantitiyDataFactitiousEnteringLog2: "/api/getQuantitiyDataFactitiousEnteringLog2",//查询统计数据录入记录
}

export default collectionData